import Vue from 'vue'
import { URL_MANAGEMENT, URL_ORGANIZATIONS } from '@/constants/urls.js'
import { REPORTS, GENERAL_FILES } from '@/constants/store.js'

const actions = {
  async [REPORTS.ACTIONS.GET_ORGANIZATIONS_REPORT] ({ dispatch }, params) {
    const url = `${Vue.getIdentityHost()}${URL_ORGANIZATIONS}/report?${Vue.helpers.getQueryParamsString(params)}`

    await dispatch(GENERAL_FILES.ACTIONS.DOWNLOAD_FILE_WITH_SETTINGS, url, { root: true })
  },
  async [REPORTS.ACTIONS.GET_ORGANIZATIONS_ACTIVITY_REPORT] ({ dispatch }, params) {
    const url = `${Vue.getAdminHost()}${URL_MANAGEMENT}/activity/statistics?${Vue.helpers.getQueryParamsString(params)}`

    await dispatch(GENERAL_FILES.ACTIONS.DOWNLOAD_FILE_WITH_SETTINGS, url, { root: true })
  },

  async [REPORTS.ACTIONS.GET_LOTS_REPORT] ({ dispatch }, params) {
    const url = `${Vue.getAdminHost()}${URL_MANAGEMENT}/lotResultStatistics?${Vue.helpers.getQueryParamsString(params)}`

    await dispatch(GENERAL_FILES.ACTIONS.DOWNLOAD_FILE_WITH_SETTINGS, url, { root: true })
  },

  async [REPORTS.ACTIONS.GET_LOT_COMMISSION_REPORT] ({ dispatch }, params) {
    const url = `${Vue.getAdminHost()}${URL_MANAGEMENT}/lotCommissionReport?${Vue.helpers.getQueryParamsString(params)}`

    await dispatch(GENERAL_FILES.ACTIONS.DOWNLOAD_FILE_WITH_SETTINGS, url, { root: true })
  },
  async [REPORTS.ACTIONS.GET_BANK_ACCOUNTS_REPORT] ({ dispatch }, params) {
    const url = `${Vue.getAdminHost()}${URL_MANAGEMENT}/bankAccountsReport?${Vue.helpers.getQueryParamsString(params)}`

    await dispatch(GENERAL_FILES.ACTIONS.DOWNLOAD_FILE_WITH_SETTINGS, url, { root: true })
  }
}

export default {
  namespaced: true,
  actions
}
